import { KpiProps } from 'app/views/components/KPI/KPI'
import { useKPIFilters } from 'app/views/components/KPI/KPI-filters'
import { AssignmentListItem } from 'app/models/assignment-list-params'
import { useEffect } from 'react'

export const getKPIData = (
  data: AssignmentListItem[] | undefined,
  setData: React.Dispatch<React.SetStateAction<AssignmentListItem[]>>,
): KpiProps[] => {
  if (!data) {
    return []
  }

  const filterFunctions: Record<
    string,
    (trade: AssignmentListItem) => boolean
  > = {
    Subtrades: (trade: AssignmentListItem) =>
      ['Pending Submit', 'Pending Review'].includes(trade.status),
    'Ready to Review Trades': (trade: AssignmentListItem) =>
      ['Pending Approval'].includes(trade.status),
    'Trades Pending Signing': (trade: AssignmentListItem) =>
      ['New Borrowing'].includes(trade.status),
    'Pending Affiliate': (trade: AssignmentListItem) =>
      ['Released'].includes(trade.status),
  }

  const { applyFilter, appliedFilters } = useKPIFilters({
    data,
    filterFunctions,
    setData,
  })

  useEffect(() => {
    if (appliedFilters.size === 0) return;
    applyFilter(null);
  }, [data]);

  const parentTrades = data
  const subtrades = data.filter(row =>
    ['Pending Submit', 'Pending Review'].includes(row.status),
  )
  const readyToReviewTrades = data.filter(row =>
    ['Pending Approval'].includes(row.status),
  )
  const tradesPendingSigning = data.filter(row =>
    ['New Borrowing'].includes(row.status),
  )
  const pendingAffiliate = data.filter(row => ['Released'].includes(row.status))

  return [
    {
      title: 'Parent Trades',
      amount: parentTrades.length,
      activeFilter: appliedFilters.size === 0,
      event: () => applyFilter('Parent Trades'),
    },
    {
      title: 'Subtrades',
      amount: subtrades.length,
      activeFilter: appliedFilters.has('Subtrades'),
      event: () => applyFilter('Subtrades'),
    },
    {
      title: 'Ready to Review Trades',
      amount: readyToReviewTrades.length,
      percentage: Math.round((readyToReviewTrades.length / data.length) * 100),
      activeFilter: appliedFilters.has('Ready to Review Trades'),
      event: () => applyFilter('Ready to Review Trades'),
    },
    {
      title: 'Trades Pending Signing',
      amount: tradesPendingSigning.length,
      activeFilter: appliedFilters.has('Trades Pending Signing'),
      event: () => applyFilter('Trades Pending Signing'),
    },
    {
      title: 'Pending Affiliate',
      amount: pendingAffiliate.length,
      activeFilter: appliedFilters.has('Pending Affiliate'),
      event: () => applyFilter('Pending Affiliate'),
    },
  ]
}
